import React from 'react';
import { AuthContext } from '../../authContext.js';
export const useToken = () => {
    const { token, setToken } = React.useContext(AuthContext);
    return [token, setToken];
};
